import React from "react";
import { Separator } from "@/components/ui/separator";
export default function CounselorProfileSection() {
  return <section id="counselor-profile-section" className="bg-secondary/30 py-16 md:py-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-5xl">

        <div className="mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground font-default leading-tight mb-4">カウンセラー紹介</h2>
          <Separator className="w-12 h-0.5 bg-primary mb-8" />
          <p className="text-foreground leading-relaxed font-default">専門的な知識と豊富な経験を持つカウンセラーが、あなたのお悩みに寄り添います。</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-[1fr_2fr] gap-10 lg:gap-16 items-start">
          <div>
            <img src="https://yotsuya-sc-room.com/wp-content/uploads/2026/05/menu_01.jpg" alt="カウンセラー 川上義之" className="w-full max-w-xs mx-auto md:max-w-none rounded-lg shadow-lg object-cover aspect-[3/4]" loading="lazy" />
          </div>

          <dl className="border-y border-border divide-y divide-border">
            <div className="grid grid-cols-[6rem_1fr] sm:grid-cols-[8rem_1fr] gap-4 py-4">
              <dt className="text-sm text-muted-foreground font-default">氏名</dt>
              <dd className="font-default"><span className="text-lg font-bold text-foreground">川上 義之</span><span className="ml-2 text-sm text-muted-foreground">Yoshiyuki Kawakami</span></dd>
            </div>
            <div className="grid grid-cols-[6rem_1fr] sm:grid-cols-[8rem_1fr] gap-4 py-4">
              <dt className="text-sm text-muted-foreground font-default">保有資格</dt>
              <dd className="text-foreground font-default">臨床心理士、公認心理師</dd>
            </div>
            <div className="grid grid-cols-[6rem_1fr] sm:grid-cols-[8rem_1fr] gap-4 py-4">
              <dt className="text-sm text-muted-foreground font-default">専門分野</dt>
              <dd className="text-foreground font-default">力動的心理療法、発達相談</dd>
            </div>
            <div className="grid grid-cols-[6rem_1fr] sm:grid-cols-[8rem_1fr] gap-4 py-4">
              <dt className="text-sm text-muted-foreground font-default">経歴</dt>
              <dd className="text-foreground leading-relaxed font-default">明治学院大学心理学科卒業後、東京国際大学臨床心理学研究科に進学。修了後は病院、福祉施設、学校などいくつかの職場での勤務経験があり、心理療法やデイケアの運営、生活支援などの業務を行っていました。2019年に新宿四谷心理カウンセリングルームを開設、現在は相談室でのカウンセリングをメインに行っています。</dd>
            </div>
            <div className="grid grid-cols-[6rem_1fr] sm:grid-cols-[8rem_1fr] gap-4 py-4">
              <dt className="text-sm text-muted-foreground font-default">メッセージ</dt>
              <dd className="text-foreground leading-relaxed font-default space-y-4">
                <p>つらい経験は、できることなら避けて通りたいものです。でも、そのつらさの中にこそ、自分自身をより深く知るヒントが隠れていることがあります。</p>
                <p>カウンセリングで目指したいのはその先——つらさと向き合うプロセスの中で自己理解を深め、成長のきっかけにしていただくこと。「少し前に進めた」と感じられる瞬間を、一緒に探っていければと思っています。</p>
              </dd>
            </div>
          </dl>
        </div>
      </div>
    </section>;
}